const maptilerApiHost = "api.maptiler.com";

const constant = {
  maptilerApiHost,
  // we use a mockup:
  endpoint: `https://${maptilerApiHost}/weather/latest.json`,
  tileSourceUrlSchema: `https://${maptilerApiHost}/tiles/{tileset_id}/{zxy}.{format}`,
};

Object.freeze(constant);

const weatherVariable = {
  TEMPERATURE: "temperature-2m:gfs", //"TEMPERATURE",
  PRECIPITATION: "precipitation-1h:gfs", //"PRECIPITATION",
  WIND: "wind-10m:gfs", //"WIND",
  PRESSURE: "pressure-msl:gfs", //"PRESSURE",
  CLOUD_COVERAGE: "cloud_cover-total:gfs", //"CLOUD_COVERAGE",
  RADAR_REFLECTIVITY: "radar-composite:gfs", //"RADAR_REFLECTIVITY",
  FROZEN_PRECIPITATION: "frozen_precipitation-1h:gfs", //"FROZEN_PRECIPITATION"
};

Object.freeze(weatherVariable);

export { constant, weatherVariable };
